module.exports = __webpack_public_path__ + "img/banner1-mb.e8f94e0d.webp";